import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { Button, CssBaseline, TextField, Link, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useHistory } from 'react-router-dom';
import { Box, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from '@material-ui/core';

import axios from 'axios';

import { COLORS } from '../../shared/Theme';
import { SIcon } from '../../shared/Icon';

import { admin as v_admin, basic, Values, SNACKBAR_TIME, edu } from '../../request/values';

const SERVER = basic.server;

const useStyles = makeStyles((theme: any) => ({
	background: {
		position: 'absolute',
		top: 0,
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	container1: {
		padding: 0,
		height: '100vh',
		marginTop: '15vh',
	},
	container2: {
		padding: 0,
		height: '100vh',
		marginTop: '2vh',
	},
	playImage: {
		width: '50%',
	},
	playImageSection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '30vw', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	logoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		marginTop: '40vh',
		marginBottom: '10vh',
	},
	logobutton: {
		border: 'none',
		backgroundColor: 'transparent',
	},
	buttonFont: {
		color: `${COLORS.WHITE}`,
		fontSize: '1vw',
	},
	border: {
		borderWidth: 5,
		borderStyle: 'solid',
		borderColor: `#000000`,
		background: `${COLORS.WHITE}`,
		padding: '1vw',
		marginTop: '1vh',
	},
	movePageButton: {
		flexDirection: 'column',
		fontSize: '1vw',
		color: `${COLORS.WHITE}`,
	},
	playButton: {
		width: '10vw',
		height: 'auto',
		marginLeft: '5vw',
	},
	playButtonImage: {
		width: '100%',
	},
	inputSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '3vw',
		fontWeight: 'bold',
		fontFamily: 'NanumB',
	},
	timerFont: {
		fontSize: '3vw',
		fontWeight: 'bold',
		fontFamily: 'NanumB',
	},
	trophySection: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: 50,
	},
	ExceptWinner: {
		backgroundColor: `${COLORS.LIGHT_GREY}`,
		width: '10vh',
		height: '9vh',
		marginBottom: 17,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '8vh',
			height: 'auto',
		},
	},
	Winner: {
		backgroundColor: `${COLORS.WATER_BLUE}`,
		width: '15vh',
		height: '13vh',
		marginRight: 60,
		marginLeft: 60,
		marginBottom: 17,

		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 20.7,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		'& img': {
			width: '13vh',
			height: 'auto',
		},
	},
	tableHeader: {
		width: '100vw',
		height: 'auto',
		// backgroundColor: `${COLORS.PUMPKIN}`,
		// background: `url("/images/ranking/header.webp")`,
		// objectFit: 'contain',
		// borderRadius: 10,
		// boxShadow: '1px 3px 6px 1px rgba(0, 0, 0, 0.16)',
	},
	tableHeaderRow: {
		width: '90vw',
		height: '5vh',
		// backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: 10,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
	},
	headerCell: {
		fontSize: '1.3vw',
		// borderRadius: 10,
		// boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		// backgroundColor: `${COLORS.WATER_BLUE}`,
	},

	tableContent: {
		height: 80,
		borderBottom: 'none',
		fontSize: '1.7vh',
		fontFamily: 'NanumB',
	},
	winnerContent: {
		'& th, td': {
			color: `${COLORS.WATER_BLUE}`,
		},
	},
	footer: {
		marginTop: 100,
		textAlign: 'center',
		paddingBottom: '10vh',
		'& img': {
			width: 166,
		},
	},
	playStartUpLogoSection: {
		display: 'flex',
		justifyContent: 'center',
		flex: 1,
		alignItems: 'flex-end',
		marginBottom: '10vh',
		marginRight: '-8vw',
		'& img': {
			width: '25vw',
			height: 'auto',
		},
	},
	upperSection: {
		display: 'flex',
	},
	infoButton: {
		borderWidth: 1,
		borderStyle: 'solid',
		borderColor: `${COLORS.CHARCHOAL_GREY}`,
		backgroundColor: `${COLORS.WATER_BLUE}`,
		borderRadius: '10px',
		margin: '0.5vh',
		width: '5vw',
	},
	endingSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	endingText: {
		fontSize: '3vw',
		fontWeight: 'bold',
		marginBottom: '10vw',
	},
}));

const HeadAdminOpenRanking: React.FC<any> = (props) => {
	const classes = useStyles();

	const [rank, setRank] = useState([
		{ company_name: '테스트', stock: 180000, loan: 0, loan_interest: 0, capital: 180000, order_inventory: 0, used_mat: 0, license_stock: 10000 },
		{ company_name: '테스트1', stock: 190000, loan: 0, loan_interest: 0, capital: 190000, order_inventory: 0, used_mat: 0, license_stock: 10000 },
		{ company_name: '테스트2', stock: 200000, loan: 0, loan_interest: 0, capital: 200000, order_inventory: 0, used_mat: 0, license_stock: 10000 },
	]);

	const history = useHistory();
	const { member } = props;

	const state: any = history.location.state;
	const classCode = state.code;
	const className = state.name;

	const AddComma = (num: number) => {
		var regexp = /\B(?=(\d{3})+(?!\d))/g;
		return num.toString().replace(regexp, ',');
	};

	const getRankContent = () => {
		axios({
			method: 'POST',
			data: {
				class_code: classCode,
			},
			withCredentials: true,
			url: SERVER + edu.path + edu.class_rank_content,
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setRank(data.rank);
				} else {
				}
			});
	};

	useEffect(() => {
		getRankContent();
	}, []);

	const movePage = () => {
		history.push({
			pathname: '/headAdminClassList',
		});
	};

	return (
		<div className={classes.background}>
			<Container component="main" className={classes.container2}>
				<CssBaseline />

				<div className={classes.upperSection}>
					<div className={classes.playStartUpLogoSection}>
						<img src="/images/ranking/logo.webp" />
					</div>
					<div className={classes.movePageButton}>
						<Button onClick={(e) => movePage()} className={classes.infoButton}>
							<Typography className={classes.buttonFont}>메인으로</Typography>
						</Button>
					</div>
				</div>

				<div className={classes.trophySection}>
					<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
						<Box className={classes.ExceptWinner}>
							<img src="/images/ranking/silver.webp" />
						</Box>
						<Typography style={{ fontSize: '1.6vh' }}>{rank[1] != undefined ? rank[1].company_name : ''}</Typography>
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
						<Box className={classes.Winner}>
							<img src="/images/ranking/gold.webp" />
						</Box>
						<Typography style={{ fontSize: '2.5vh' }}>{rank[0] != undefined ? rank[0].company_name : ''}</Typography>
					</div>
					<div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
						<Box className={classes.ExceptWinner}>
							<img src="/images/ranking/bronze.webp" />
						</Box>
						<Typography style={{ fontSize: '1.6vh' }}>{rank[2] != undefined ? rank[2].company_name : ''}</Typography>
					</div>
				</div>

				<TableContainer
					component={Paper}
					style={{
						backgroundColor: `transparent`,
						// borderRadius: 10,
						boxShadow: 'none',
					}}
				>
					<Table size="small" aria-label="a dense table">
						<TableHead className={classes.tableHeader}>
							<TableRow className={classes.tableHeaderRow}>
								<TableCell width="10%" align="center" className={classes.headerCell}>
									순위
								</TableCell>
								<TableCell width="24.7%" align="center" className={classes.headerCell}>
									기업명
								</TableCell>
								<TableCell width="7%" align="center" className={classes.headerCell}>
									자산
								</TableCell>
								<TableCell width="5%" align="center" className={classes.headerCell}>
									-
								</TableCell>
								<TableCell width="7%" align="center" className={classes.headerCell}>
									부채
								</TableCell>
								<TableCell width="5%" align="center" className={classes.headerCell}>
									=
								</TableCell>
								<TableCell width="7%" align="center" className={classes.headerCell}>
									자본
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{rank.length != 0 &&
								rank.map((row, index) => (
									<TableRow
										key={row.company_name}
										className={index == 0 ? classes.winnerContent : ''}
										// sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
									>
										<TableCell width="10%" component="th" scope="row" align="center" className={classes.tableContent}>
											{`${index + 1}위`}
										</TableCell>
										<TableCell width="15vw" align="center" className={classes.tableContent}>
											{row.company_name}
										</TableCell>
										<TableCell width="7%" align="center" className={classes.tableContent}>
											{AddComma(row.stock + row.order_inventory - row.used_mat + row.license_stock) + '원'}
										</TableCell>
										<TableCell width="5%" align="center" className={classes.tableContent}></TableCell>
										<TableCell width="7%" align="center" className={classes.tableContent}>
											{AddComma(row.loan + row.loan_interest) + '원'}
										</TableCell>
										<TableCell width="5%" align="center" className={classes.tableContent}></TableCell>
										<TableCell width="7%" align="center" className={classes.tableContent}>
											{AddComma(row.capital + row.license_stock) + '원'}
										</TableCell>
									</TableRow>
								))}
						</TableBody>
					</Table>
				</TableContainer>

				<div className={classes.footer}>
					<img src="/images/spreneur.webp" />
				</div>

				<div className={classes.logoSection}>
					<SIcon type="P" />
				</div>
			</Container>
		</div>
	);
};

export default HeadAdminOpenRanking;
